
import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import Navbar from '@/components/Navbar';
import CreditsCard from '@/components/dashboard/CreditsCard';
import ReferralSection from '@/components/dashboard/ReferralSection';

const CreditsReferrals = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white">Loading user data...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      
      <div className="container mx-auto pt-24 px-4 pb-16">
        <h1 className="text-2xl font-bold mb-6">Credits & Referrals</h1>
        
        {/* Credits Section */}
        <div className="mb-8">
          <h2 className="text-xl font-bold mb-4">Your Investment Credits</h2>
          <CreditsCard />
        </div>
        
        {/* Referral Section */}
        <div>
          <h2 className="text-xl font-bold mb-4">Refer & Earn</h2>
          <ReferralSection userEmail={user.email} />
        </div>
      </div>
    </div>
  );
};

export default CreditsReferrals;
